import { Grid, Typography } from '@mui/material';
import React from 'react';
import TranscriptionData from './TranscriptionData';
import OrderSummaryDisplay from './OrderSummaryDisplay';
import PropTypes from 'prop-types';

function AddOrEditOrderDetails(props) {
    const {
        callRecAndTrainingDataToDisplay,
        rowId,
        removeItemFromOrder,
        updateTranscriptionTextForRow,
    } = props;

    return (
        <>
            <Grid
                direction={'row'}
                container
                spacing={2}
                style={{ paddingTop: 20 }}
                maxHeight={'15vh'}
            >
                <Grid
                    container
                    item
                    style={{
                        position: 'relative',
                        zIndex: 5,
                        width: '25%',
                    }}
                >
                    <Grid item xs={12}>
                        <Typography
                            variant="h6"
                            align="center"
                            style={{ fontWeight: 'bold' }}
                        >
                            Call Recording
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <audio controls style={{ width: '100%' }}>
                            <source
                                src={
                                    callRecAndTrainingDataToDisplay.recordingUrl
                                }
                                type="audio/mpeg"
                            />
                            Your browser does not support the audio element.
                        </audio>
                    </Grid>
                </Grid>
                <Grid
                    container
                    item
                    style={{
                        position: 'relative',
                        zIndex: 5,
                        width: '45%',
                    }}
                >
                    <Grid item xs={12}>
                        <Typography
                            variant="h6"
                            align="center"
                            style={{ fontWeight: 'bold' }}
                        >
                            Transcription
                        </Typography>
                    </Grid>
                    <Grid item xs={12} style={{ maxHeight: '15vh' }}>
                        <TranscriptionData
                            transcriptionData={
                                callRecAndTrainingDataToDisplay.parsedTranscriptionByCrowd ||
                                callRecAndTrainingDataToDisplay.parsedTranscriptionByAI
                            }
                            updateTranscriptionTextForRow={
                                updateTranscriptionTextForRow
                            }
                            rowId={rowId}
                            allowEdits={true}
                        />
                    </Grid>
                </Grid>
                <Grid
                    container
                    item
                    style={{
                        position: 'relative',
                        zIndex: 5,
                        width: '25%',
                    }}
                >
                    <Grid item xs={12}>
                        <Typography
                            variant="h6"
                            align="center"
                            style={{ fontWeight: 'bold' }}
                        >
                            Items in Order
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        style={{ maxHeight: '15vh', overflowY: 'auto' }}
                    >
                        <OrderSummaryDisplay
                            rowId={callRecAndTrainingDataToDisplay.id}
                            itemsInOrder={
                                callRecAndTrainingDataToDisplay.orderSummaryByCrowd ||
                                callRecAndTrainingDataToDisplay.orderSummaryByAI
                            }
                            rowHeight={300}
                            showEditButton={false}
                            removeItemFromOrderSummaryForRow={
                                removeItemFromOrder
                            }
                            // updateTranscriptionTextForRow={
                            //     updateTranscriptionTextForRow
                            // }
                        />
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

AddOrEditOrderDetails.propTypes = {
    callRecAndTrainingDataToDisplay: PropTypes.shape({
        id: PropTypes.string.isRequired,
        recordingUrl: PropTypes.string.isRequired,
        parsedTranscriptionByAI: PropTypes.arrayOf(PropTypes.string).isRequired,
        parsedTranscriptionByCrowd: PropTypes.arrayOf(PropTypes.string),
        orderSummaryByCrowd: PropTypes.arrayOf(
            PropTypes.shape({
                key: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
                quantity: PropTypes.number.isRequired,
            })
        ),
        orderSummaryByAI: PropTypes.arrayOf(
            PropTypes.shape({
                key: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
                quantity: PropTypes.number.isRequired,
            })
        ),
    }).isRequired,
};

export default AddOrEditOrderDetails;
